export const GET_DEVICE_LIST = 'GET_DEVICE_LIST'
export const GET_IMAGESOUND_PLAYERS = 'GET_IMAGESOUND_PLAYERS'
